<template>
    <div>
		<!-- Modal -->
		<b-modal	id="modal-1"
					title="Please Log In"
					centered
					hide-footer
					ok-only
					ok-title="Cancel">
			<b-form @submit.prevent="handleSubmit">
                <b-form-group label="Username:" label-for="loginUsername" :description="usernameWarning.msg">
                    <b-input id="loginUsername" v-model="username" :state="usernameWarning.state" />
                </b-form-group>
                <b-form-group label="Password:" label-for="loginPassword" :description="passwordWarning.msg">
                    <b-form-input id="loginPassword" type="password" v-model="password" :state="passwordWarning.state" />
                </b-form-group>
                <b-button type="submit" variant="primary" block size="lg">Login</b-button>
            </b-form>
		</b-modal>

		<!-- Main Body -->
		<div class="text-center">
			<h1>Welcome!</h1>
			<b-button	variant="success"
						@click.prevent="$bvModal.show('modal-1')">
				Gifts Portal
			</b-button>
		</div>
    </div>
</template>

<script>
/* eslint-disable no-console */
import { store } from '../_store'
const jwt = require('jsonwebtoken')
const jwtConfig = require('../_configs/jwtConfig')

export default {
    data() {
        return {
			username: '',
			password: '',
			submitted: false
        }
	},
	computed: {
        usernameWarning() {
            if(this.submitted && !this.username) {
                return { msg: 'Username is required', state: false }
            } else {
                return { msg: '', state: undefined }
            }
        },
        passwordWarning() {
            if(this.submitted && !this.password) {
                return { msg: 'Password is required', state: false }
            } else {
                return { msg: '', state: undefined }
            }
        }
    },
    methods: {
        handleSubmit() {
            this.submitted = true
            let self = this
            if(this.username && this.password) {
                this.$store.dispatch('authentication/login', { username: self.username, password: self.password })
            }
        }
    },
    created() {
        let theToken = localStorage.getItem('ben-token')
        if(theToken) {
            jwt.verify(theToken, jwtConfig.default.secret, function() {
				store.dispatch('authentication/reLogIn', { reload: false })
            })
        }
    }
}
</script>

<style>

    

</style>